<template>
  <v-app id="inspire">
    <v-card-title>
      Organizations
      <v-spacer></v-spacer>
      <v-btn @click="changePathEditOrganization()" color="secondary"> Add New </v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getOrganizations"
      :hide-default-footer="true"
      disable-pagination
      item-key="id"
    >
      <template v-slot:item.image="{ item }">
        <img v-if="item.image" :src="item.image" style="width: 50px; height: 50px" />
      </template>
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <!-- DELETE organization BUTTON-->
        <div id="editTemplateRow" class="row">
          <div class="col-3">
            <v-btn icon @click="changePathEditOrganization(item.id)" color="secondary"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
          </div>

          <div class="col-2">
            <v-btn icon @click="deleteShootingOrganization(item.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
  import { GET_ORGANIZATIONS, DELETE_ORGANIZATION } from '../../graphql/organizationQueries';

  export default {
    components: {
      CConfirmationDialog: () => import('../common/CConfirmationDialog'),
    },
    data() {
      return {
        id: '',
        search: '',
        getOrganizations: [],
        headers: [
          { text: 'Image', value: 'image', align: 'left', sortable: false },
          { text: 'Name', value: 'name', align: 'left', sortable: false },
          { text: 'Governor', value: 'governorOrganizationId', align: 'left', sortable: false },
          { text: 'ID', value: 'id', align: 'left', sortable: false },
          {
            text: '',
            value: 'actions',
            sortable: false,
          },
        ],
      };
    },
    apollo: {
      $client: 'organizationClient',
      getOrganizations: {
        query: GET_ORGANIZATIONS,
        loadingKey: 'loading',
      },
    },
    created() {
      this.$apollo.queries.getOrganizations.refetch();
    },
    methods: {
      async deleteShootingOrganization(id) {
        if (await this.$refs.confirmationDialog.open('Are you sure you want to delete this organization?')) {
          try {
            await this.$apollo.mutate({
              mutation: DELETE_ORGANIZATION,
              variables: {
                id: id,
              },
            });
          } catch (err) {
            alert('Error deleting template! ' + err.message);
          }
          this.$apollo.queries.getOrganizations.refetch();
        }
      },
      changePathEditOrganization(id) {
        let pathURL = '/addoreditorganization/';
        if (id) {
          pathURL += id;
        }
        this.$router.push({ path: pathURL });
      },
    },
  };
</script>

<style scoped>
  @media only screen and (max-width: 1000px) {
    #editTemplateRow {
      width: 10%;
    }
  }
</style>
